import * as Actions from "./actions";
import _ from "lodash";

const initialState = {
  isInSession: false,
  data: null,
  update: {
    isLoading: false,
    errors: null,
    success: null,
  },
  cancel: {
    isLoading: false,
    errors: null,
    success: null,
  },
  reschedule: {
    isLoading: false,
    errors: null,
    success: null,
  },
  load: {
    isLoading: false,
    errors: null,
    success: null,
  },
  create: {
    isLoading: false,
    errors: null,
    success: null,
  },
  ws: {
    message: null,
    event: null,
  },
  next: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    /** ************************************ */
    // LOAD TREATMENTS
    /** ************************************ */

    case Actions.SAVE_TREATMENT:

      return { ...state,
        data: _.cloneDeep(payload),
      };

    case Actions.LOAD_TREATMENTS.REQUEST:

      return { ...state,
        load: {
          isLoading: true,
          errors: null,
          success: null,
        } };

    case Actions.LOAD_TREATMENTS.SUCCESS:

      return { ...state,
        load: {
          isLoading: false,
          errors: null,
          success: true,
        } };

    case Actions.LOAD_TREATMENTS.FAILURE:

      return { ...state,
        load: {
          isLoading: false,
          errors: payload,
          success: false,
        } };

    /** ************************************ */
    // CREATE TREATMENT
    /** ************************************ */
    case Actions.CREATE_TREATMENT.REQUEST:

      return { ...state,
        create: {
          isLoading: true,
          errors: null,
          success: null,
        } };

    case Actions.CREATE_TREATMENT.SUCCESS:

      return { ...state,
        create: {
          isLoading: false,
          errors: null,
          success: true,
        } };

    case Actions.CREATE_TREATMENT.FAILURE:

      return { ...state,
        create: {
          isLoading: false,
          errors: payload,
          success: false,
        } };

      // /***************************************/
      // // UPDATE TREATMENT
      // /***************************************/

    case Actions.UPDATE_TREATMENT.REQUEST:

      return { ...state,
        update: {
          isLoading: true,
          errors: null,
          success: null,
        } };

    case Actions.TOGGLE_IN_SESSION:
      return { ...state, isInSession: payload };

    case Actions.UPDATE_TREATMENT.SUCCESS:

      return { ...state,
        update: {
          isLoading: false,
          errors: null,
          success: true,
        } };

    case Actions.UPDATE_TREATMENT.FAILURE:

      return { ...state,
        update: {
          isLoading: false,
          errors: payload,
          success: false,
        } };

      // /***************************************/
      // // CANCEL TREATMENT
      // /***************************************/

    case Actions.CLEAR_TREATMENT:
      return { ...state, data: null };

    case Actions.CANCEL_TREATMENT.REQUEST:
      return { ...state,
        cancel: {
          isLoading: true,
          errors: null,
          success: null,
        } };

    case Actions.CANCEL_TREATMENT.SUCCESS:
      return { ...state,
        cancel: {
          isLoading: false,
          errors: null,
          success: true,
        } };

    case Actions.CANCEL_TREATMENT.FAILURE:
      return { ...state,
        cancel: {
          isLoading: false,
          errors: payload,
          success: false,
        } };

      // /***************************************/
      // // RESCHEDULE TREATMENT
      // /***************************************/

    case Actions.RESCHEDULE_TREATMENT.REQUEST:

      return { ...state,
        reschedule: {
          isLoading: true,
          errors: null,
          success: null,
        } };

    case Actions.RESCHEDULE_TREATMENT.SUCCESS:

      return { ...state,
        reschedule: {
          isLoading: false,
          errors: null,
          success: true,
        } };

    case Actions.RESCHEDULE_TREATMENT.FAILURE:

      return { ...state,
        reschedule: {
          isLoading: false,
          errors: payload,
          success: false,
        } };

    default:
      return state;
  }
};
